import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const RepLITextFieldSkeleton = props => {
    return (
        <Skeleton variant="rectangle" style={{ margin: 16, height: 50 }} {...props}>
            {props.children}
        </Skeleton>
    );
};

export default RepLITextFieldSkeleton;